import Loaging from "common/Loaging";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Table from "../components/common/Tablet";
import { getVideoInstagramGac } from "services/instagram";

const columns = [
  { key: "id", label: "#" },
  { key: "code", label: "Código" },
];

export const PageInstagran = () => {
  const [codeInstagram, setCodeInstagram] = useState(null);

  const listCode = async () => {
    try {
      const { data } = await getVideoInstagramGac();
      setCodeInstagram(data);
    } catch (error) {
      console.log(error);
      alert("No se pudo obtener el listado de historias de instagram");
    }
  };

  useEffect(() => {
    listCode();
  }, []);

  return (
    <article>
      <h1 className="centrar">Lista de valores afiliados</h1>
      <NavLink
        className="btn-about-contact btn-add-banner"
        to="/d77cdf4f4ab48f705fbed94d26c7ee03831add4b9cbe2a4c7c578f8cc7361215/history-instagram"
      >
        Agregar historia de instagram
      </NavLink>

      {!codeInstagram ? (
        <Loaging />
      ) : (
        <Table
          columns={columns}
          data={codeInstagram}
          onEdit={() => console.log("ACTION")}
          onDelete={() => console.log("ACTION")}
        />
      )}
    </article>
  );
};
